import { Collection } from "@authory-packages/core";

export const getV3ProfileCollections = (collections?: Collection[]) => {
    const profileCollections = (collections || []).sort((a, b) => a.order - b.order).filter((col) => col.partOfProfile);

    const firstCollection = profileCollections.length ? profileCollections[0] : undefined;

    return { profileCollections, firstCollection };
};
